import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { ITkDataTableHeadePorps } from "../../type/componentsType/TkDataTable";

const facilitySelectList: ITkFakeTableLineProps = {
  title: "施設選択",
  type: "selectForm",
  helpicon: true,
  helpText: "対象となる施設を選択します。",
};

const fakeHeadTitleList: ITkDataTableHeadePorps[] = [
  {
    headTitle: "氏名",
    helpText:
      "登録されている被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されていない場合があります。",
  },
  {
    headTitle: "生年月日",
    helpText: "登録されている被共済職員の生年月日です。",
  },
  {
    headTitle: "性別",
    helpText: "登録されている被共済職員の性別です。",
  },
  {
    headTitle: "本俸月額\n（俸給表の額+俸給の調整額）\n※自動計算されます",
    helpText:
      "「俸給表の額」と「俸給の調整額」を合わせた額で退職手当金の算定基礎となる金額です。",
  },
  {
    headTitle:
      "俸給表の額\n（給与規程又は雇用契約書で定めた額）\n※実支給額ではありません",
    helpText: (
      <>
        共済契約者が給与規程で定める本俸月額を入力してください。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載してください。
      </>
    ),
  },
  {
    headTitle:
      "俸給の調整額\n（対象手当として機構が認めた額）\n※認められていない額は計上できません",
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めた手当があれば、その合計金額を入力してください。登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。
        <br />
        ※俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    className: "latestUpdateDate",
    headTitle: "本俸月額最終更新日",
    helpText: "本俸月額を最後に更新した日です。",
  },
];

const searchFormList: any = [
  {
    label: "氏名",
    keyword: "name",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  name: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

export {
  facilitySelectList,
  fakeHeadTitleList,
  searchFormList,
  searchFormSchema,
};
